module.exports = __webpack_public_path__ + "img/Tick.3c6868e2.svg";